export const eventWidgetStyleProps = {
    fontSize: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
    minWidth: '320px',
    maxWidth: '700px',
    margin: 'auto',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'accent',
    borderRadius: '12px',
    overflow: 'auto',
};

export const pulseLoaderContainerStyleProps = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
};
